import React from "react";

const Keyword = ({ keyword }) => {
  return <div>{keyword}</div>;
};

export default Keyword;
